module.exports = __webpack_public_path__ + "static/media/check.c9deb4e7.svg";